<template>
  <div class="body">
    <!-- Header -->
    <SocialLinks />
    <TopBar />
    <NavBar />
    <HorisontalNewsSection/>
    <router-view></router-view>
   
    
    
    <!-- Footer -->
    <footer class="bg-success text-white py-3 text-center">
      <p>&copy; 2024 MUI-KENDAL. All rights reserved.</p>
    </footer>
  </div>
</template>

<script>

import HorisontalNewsSection from "./components/SectionNewsHorisontal.vue";
import TopBar from "./components/TopBar.vue";
import NavBar from "./components/NavBar.vue";
import SocialLinks from "./components/SocialMedia.vue";
export default {
  components: {
    SocialLinks,
    NavBar,
    TopBar,
    HorisontalNewsSection,
  },
  name: "HalamanHome",
};


</script>


<style>
.body{
  background-color: #f9f9f9;
}

.bg-green{
  background-color: #3f9153;
}
</style>

